export const FormCommonValidatorName = {
  Required: 'required',
  Email: 'email',
  Phone: 'phone',
  Time: 'time',
  EmptyText: 'emptyText',
  MinLength: 'minLength',
  MaxLength: 'maxLength',
  Min: 'min',
  Max: 'max',
  Url: 'url',
  FileSize: 'fileSize',
};

export default {
  FormCommonValidatorName,
};
